import { render, staticRenderFns } from "./DocumentRequest.vue?vue&type=template&id=6c590ebc&lang=pug"
import script from "./DocumentRequest.vue?vue&type=script&lang=js"
export * from "./DocumentRequest.vue?vue&type=script&lang=js"
import style0 from "./DocumentRequest.vue?vue&type=style&index=0&id=6c590ebc&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports